import { useState } from 'react';
import config from '../../utils/apiUrl';

const useAuthorizeEntity = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  const authorizeEntity = async (id, source, auth) => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      let url = '';
      switch (source) {
        case 'campaña':
          url = 'company/admin/updateCampaign/authorize';
          break;
        case 'fundación':
          url = 'company/admin/updateFoundation/authorize';
          break;
        default:
          throw new Error('Fuente inválida para la autorización');
      }

      const res = await fetch(`${config.apiUrl}/${url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id, auth }),
      });

      const result = await res.json();

      if (!res.ok) {
        throw new Error(
          result.message || 'Falló la autorización de la entidad'
        );
      }

      setResponse(result);
      return result;
    } catch (err) {
      setError(err.message || 'Ocurrió un error');
      return null
    } finally {
      setLoading(false);
    }
  };

  return { authorizeEntity, loading, error, response };
};

export default useAuthorizeEntity;
